import React, {Component} from 'react';
import connect from 'react-redux/es/connect/connect';
import ErrorUIComponent from '../utils/ErrorUIComponent';
import { 
    fetchColaboradores, 
    clearColaboradores,
    fetchPermisos, 
    fetchTipoActividad, 
    fetchHistorialFDV,
    fetchFamilia,
    fetchFiliales,
    fetchAreasVenta,
    fetchVendedores,
    clearVendedores,
    fetchClientes,
    clearClientes,
    fetchEventoActividad
} from '../actions';
import {Link} from 'react-router-dom';
import moment from 'moment';
import Autocomplete from "react-autocomplete";
import addComment from '../utils/addComment';

const menuStyle = {
    position: 'absolute',
    left: '0',
    top: '100%',
    maxHeight: '350px',
    overflow: 'auto',
    border: '1px solid #cccccc',
    zIndex: '100',
  };
  
const inputPropsColaborador = {
    className: 'form-control awesomplete pillSelct-input',
    name: 'colaborador',
    placeholder: 'Seleccione Vendedor'
};

const inputPropsCliente = {
    className: 'form-control awesomplete pillSelct-input',
    name: 'cliente',
    placeholder: 'Seleccione Cliente'
};

const listaClientesNull = {
    codigo:'00',
    nombre:'Sin Valor'
}

const listarColaboradorNull = {
    idUsuario: '00',
    nombre: 'Sin Valor',
    apellidos: 'Sin Valor'
}


const CONSULTA_CLIENTES='cadena'
const CONSULTA_TIPO='A'

// [I] MNBARDALES FECHA PASE 27/09/2021 
class IndexBandejaActividades extends Component {

    static pillFormatter(cell) {
        switch (cell) {
            case 'R':
                return <span className='pill pill-block pill-green'>{'Realizado'}</span>;
            case 'C':
                return <span className='pill pill-block pill-red'>{'Rechazado'}</span>;
            default:
                return <span className='pill pill-block'>{'Pendiente'}</span>;
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            // Para Tipo de Actividad
            estado: 'P',
            comboActividad: '0',
            comboAreaVta: '0',
            comboFamilia: '0',
            comboSucursal: '0',    
            colaborador: '',
            colaboradores: [],
            codColaborador: 'N',
            cliente: '',
            clientes: [],
            listaClientes: [],
            listaClientesAux: [],
            codCliente: 'N',
            listaTipoActividad: [],
            listaTipoActividadAux: [],
            listaFamilia: [],
            listaFiliales: [],
            listaAreaVta: [],
            listaColaboradores: [],
            listaColaboradoresAux: [],
            listaEventoActividad: [],
            listaEventoActividadOld: [],
            listaEventoActividadAux: [],
            muestraModalRechazado: 'none',
            muestraModalRealizado: 'none',
            obsMotivoRechazo: '',
            obsComentarioRealizado: '',
            colaboradorRealizado: '',
            listaColaboradoresRealizado :[],
            colaboradorRechazo: '',
            listaColaboradoresRechazo: [],
            nroFichaVentaSeleccionado: '',
            nroEventoPadreSeleccionado: ''
        }

    }

    componentDidMount(){

        const promises = [];
        promises.push(this.props.fetchTipoActividad());
        promises.push(this.props.fetchFamilia());
        promises.push(this.props.fetchFiliales());
        promises.push(this.props.fetchAreasVenta());
        //promises.push(this.props.fetchClientes('cadena', ''));
        promises.push(this.props.fetchEventoActividad('N'));

        Promise.all(promises).then((result) => {
            console.log('data tipo actividad : ' + result[0].payload.data.listaTipoActividad);
            console.log('data tipo familia : ' + result[1].payload.data.busqueda);
            console.log('data tipo filiales : ' + result[2].payload.data.itemList);
            console.log('data tipo areas venta : ' + result[3].payload.data.itemList);
            //console.log('data tipo clientes : ' + result[4].payload.data.data);
            console.log('data tipo tareas : ' + result[4].payload.data.listaEventoActividad);
            this.setState({
                listaTipoActividad: result[0].payload.data.listaTipoActividad,
                listaTipoActividadAux: result[0].payload.data.listaTipoActividad,
                listaFamilia: result[1].payload.data.busqueda,
                listaFiliales: result[2].payload.data.itemList,
                listaAreaVta: result[3].payload.data.itemList,
                //listaClientes: result[4].payload.data.data
                listaEventoActividadOld: result[4].payload.data.listaEventoActividad,
                listaEventoActividadAux: result[4].payload.data.listaEventoActividad
            });

            this.listaEventoActividad();

        }).catch(error => console.log(error));
        
    }

    listaEventoActividad() {
        const { listaEventoActividadAux, estado } = this.state;

        console.log(listaEventoActividadAux);
        console.log(estado);

        let listaEventoActividad = [];
        listaEventoActividad = listaEventoActividadAux.filter(actividad => actividad.indTarea == estado);

        this.setState({ listaEventoActividad });

    }

    listaEventoActividadXEstado(estado) {

        const promises = [];
        if (estado == 'R') {
            promises.push(this.props.fetchEventoActividad('R'));
        } else {
            promises.push(this.props.fetchEventoActividad('N'));
        }
        
        Promise.all(promises).then((result) => {
            console.log(result);
            const { 
                comboActividad, 
                comboAreaVta, 
                comboFamilia, 
                comboSucursal, 
                //listaEventoActividadAux,
                codColaborador,
                codCliente,
                colaborador,
                cliente
            } = this.state;
    
            let listaDefault = result[0].payload.data.listaEventoActividad;
            let listaEventoActividad = [];
    
            if (comboActividad == '0' && comboAreaVta == '0' && comboFamilia == '0' && comboSucursal == '0') {
                listaEventoActividad = result[0].payload.data.listaEventoActividad;
            }
    
            if (comboActividad != '0') {
                listaEventoActividad = listaDefault.filter(actividad => actividad.idTarea == comboActividad);
                listaDefault = listaEventoActividad;
            }
            
            if (comboAreaVta != '0') {
                listaEventoActividad = listaDefault.filter(actividad => actividad.codAreaVta == comboAreaVta);
                listaDefault = listaEventoActividad;
            } 
    
            if (comboFamilia != '0') {
                listaEventoActividad = listaDefault.filter(actividad => actividad.codFamiliaVeh == comboFamilia);
                listaDefault = listaEventoActividad;
            }
    
            if (comboSucursal != '0') {
                listaEventoActividad = listaDefault.filter(actividad => actividad.codFilial == comboSucursal);
                listaDefault = listaEventoActividad;
            }
    
            if(codColaborador != 'N') {
                if(colaborador != '') {
                    listaEventoActividad = listaDefault.filter(actividad => actividad.codUsuaSolicitante == codColaborador);
                    listaDefault = listaEventoActividad;
                }
            } 
    
            if (codCliente != 'N') {
                if(cliente != ''){
                    listaEventoActividad = listaDefault.filter(actividad => actividad.codClie == codCliente);
                    listaDefault = listaEventoActividad;
                }
            }
    
            if (estado != '') {
                if (estado == 'P') {
                    listaEventoActividad = listaDefault.filter(actividad => actividad.indTarea == estado);
                    listaDefault = listaEventoActividad;
                } else {
                    listaEventoActividad = listaDefault.filter(actividad => actividad.indTarea == 'C' || actividad.indTarea == 'R');
                    listaDefault = listaEventoActividad;
                }
            }
    
            this.setState({ listaEventoActividad });
        });

        

    }

    // PARA COMBO ACTIVIDAD
    changeCombos = e => {
        this.setState({ [e.target.name]: e.target.value });
    }

    onChangeValue = e => {
        this.setState({ [e.target.name]: e.target.value });
    }

    changeColaborador = (e) => {
        this.onChangeValue(e);
        if (e.target.value.length >= 2) {
          this.props.fetchColaboradores(e.target.value).then((data) => {
            console.log(data);
            this.setState({
                listaColaboradores: data.payload.data.usuarioList,
                listaColaboradoresAux: data.payload.data.usuarioList
            })
          });
        } else if (e.target.value.length === 0) {
          this.props.clearColaboradores();
        }
    }

    changeCliente = e => {
        this.onChangeValue(e);
        if (e.target.value.length >= 2) {
          this.props.fetchClientes("cadena", e.target.value).then((data) => {
            this.setState({ 
                listaClientes: data.payload.data.data,
                listaClientesAux: data.payload.data.data 
            });
          });
        } else if (e.target.value.length === 0) {
          this.props.clearClientes();
        }
      };

    selectColaborador = (key) => {

        console.log(this.state.listaColaboradoresAux);
        
        const nombre = this.state.listaColaboradoresAux.filter(
            ({ idUsuario }) => idUsuario.toString() === key
        )[0].nombre;

        const apellidos = this.state.listaColaboradoresAux.filter(
            ({ idUsuario }) => idUsuario.toString() === key
        )[0].apellidos;

        const codUsuario = this.state.listaColaboradoresAux.filter(
            ({ idUsuario }) => idUsuario.toString() === key
        )[0].codUsuario;

        let clienteSelected = nombre + ' ' + apellidos;

        const colaboradores = { idUsuario: key, nombre: `${nombre} `, apellidos: `${apellidos} ` }

        this.setState({
            colaborador: `${clienteSelected}`,
            listaColaboradores: [colaboradores],
            codColaborador: codUsuario
        })
    }

    selectCliente = key => {
        const clienteSelected = this.state.listaClientesAux.filter(
            ({ codigo }) => codigo.toString() === key
        )[0].nombre;

        const clientes = { codigo: key, nombre: `${clienteSelected} ` }

        this.setState({
            cliente: `${clienteSelected}`,
            listaClientes: [clientes],
            codCliente: key
        })
    };

    

    handleClick(estado) {
        this.setState({ estado: estado });
        this.listaEventoActividadXEstado(estado);
    }

    atras(){

    }

    siguiente() {

    }

    rechazarActividad(e, actividad) {
        console.log(e);
        console.log(actividad);
        this.setState({ 
            nroFichaVentaSeleccionado: actividad.nroFichaVta,
            nroEventoPadreSeleccionado: actividad.nurEventoFichaVta
         });
        this.abrirModalRechazado();
    }

    realizarActividad(e, actividad) {
        console.log(e);
        console.log(actividad);
        this.setState({ 
            nroFichaVentaSeleccionado: actividad.nroFichaVta,
            nroEventoPadreSeleccionado: actividad.nurEventoFichaVta
        });
        this.abrirModalRealizado();
    }

    filtrarListaEventoActividad = () => {
        
        console.log(this.state.estado);
        const promises = [];
        if (this.state.estado == 'P') {
            promises.push(this.props.fetchEventoActividad('N'));
        } else {
            promises.push(this.props.fetchEventoActividad('R'));
        }
        
        Promise.all(promises).then((result) => {
        console.log(result);
            const { 
                comboActividad, 
                comboAreaVta, 
                comboFamilia, 
                comboSucursal, 
                colaborador, 
                cliente, 
                //listaEventoActividadAux,
                codColaborador,
                codCliente,
                estado
            } = this.state;

            let listaDefault = result[0].payload.data.listaEventoActividad;
            let listaEventoActividad = [];

            console.log('comboSucursal : ' + comboSucursal);

            if (comboActividad == '0' && comboAreaVta == '0' && comboFamilia == '0' && comboSucursal == '0') {
                listaEventoActividad = result[0].payload.data.listaEventoActividad;
            }

            if (comboActividad != '0') {
                listaEventoActividad = listaDefault.filter(actividad => actividad.idTarea == comboActividad);
                listaDefault = listaEventoActividad;
            }
            
            if (comboAreaVta != '0') {
                listaEventoActividad = listaDefault.filter(actividad => actividad.codAreaVta == comboAreaVta);
                listaDefault = listaEventoActividad;
            } 

            if (comboFamilia != '0') {
                listaEventoActividad = listaDefault.filter(actividad => actividad.codFamiliaVeh == comboFamilia);
                listaDefault = listaEventoActividad;
            }

            if (comboSucursal != '0') {
                listaEventoActividad = listaDefault.filter(actividad => actividad.codFilial == comboSucursal);
                listaDefault = listaEventoActividad;
            }

            if(codColaborador != 'N') {
                if(colaborador != '') {
                    listaEventoActividad = listaDefault.filter(actividad => actividad.codUsuaSolicitante == codColaborador);
                    listaDefault = listaEventoActividad;
                }
            } 

            if (codCliente != 'N') {
                if(cliente != '') {
                    listaEventoActividad = listaDefault.filter(actividad => actividad.codClie == codCliente);
                    listaDefault = listaEventoActividad;
                }
            }

            if (estado != '') {
                if (estado == 'P') {
                    listaEventoActividad = listaDefault.filter(actividad => actividad.indTarea == estado);
                    listaDefault = listaEventoActividad;
                } else {
                    listaEventoActividad = listaDefault.filter(actividad => actividad.indTarea == 'C' || actividad.indTarea == 'R');
                    listaDefault = listaEventoActividad;
                }
                
            }

            this.setState({ listaEventoActividad });
        });
    }

    limpiarFiltros = () => {
        this.setState({
            codCliente: 'N',
            cliente: '',
            codColaborador: 'N',
            colaborador: '',
            comboActividad: '0',
            comboAreaVta: '0',
            comboFamilia: '0',
            comboSucursal: '0',
            estado: 'P'
        }); 

        this.componentDidMount();
    }

    onChangeValueObsRechazo = e => {
        this.setState({ obsMotivoRechazo: e.target.value});
    }

    onChangeValueObsRealizado = e => {
        this.setState({ obsComentarioRealizado: e.target.value })
    }


    abrirModalRechazado() {
        this.setState({muestraModalRechazado: 'block'});
    }

    cerrarModalRechazado = () => {
        this.setState({muestraModalRechazado: 'none'});
        this.cancelarRechazado();
    }

    enviarRechazado = () => {
        console.log('enviarRechazado');
        console.log(this.state.obsMotivoRechazo);
        console.log(this.state.listaColaboradoresRechazo);
        console.log(this.state.nroFichaVentaSeleccionado);
        console.log(this.state.nroEventoPadreSeleccionado);
    
        const { obsMotivoRechazo, nroFichaVentaSeleccionado, nroEventoPadreSeleccionado } = this.state;
        if (obsMotivoRechazo.trim()) {
            addComment(nroFichaVentaSeleccionado, 'ACTIVIDAD-RECHAZADO', obsMotivoRechazo, nroEventoPadreSeleccionado,'00',this.state.listaColaboradoresRechazo.map((item) =>  item.id))
            .then(({ data }) => {
                this.cerrarModalRechazado();
                this.componentDidMount();
                console.log(data);
                //this.props.openAlert(data);
            });
        }
    }

    cancelarRechazado = () => {
        console.log('cancelarRechazado');
        this.setState({
            muestraModalRechazado: 'none',
            colaboradorRechazo: '',
            listaColaboradoresRechazo: [],
            obsMotivoRechazo: '',
            nroFichaVentaSeleccionado: '',
            nroEventoPadreSeleccionado: ''
        });
    }

    abrirModalRealizado() {
        this.setState({muestraModalRealizado: 'block'});
    }

    cerrarModalRealizado = () => {
        this.setState({muestraModalRealizado: 'none'});
        this.cancelarRealizado();
    }

    enviarRealizado = () => {
        console.log('enviarRealizado');
        console.log(this.state.obsComentarioRealizado);
        console.log(this.state.listaColaboradoresRealizado);
        console.log(this.state.nroFichaVentaSeleccionado);
        console.log(this.state.nroEventoPadreSeleccionado);
    
        const { obsComentarioRealizado, nroFichaVentaSeleccionado, nroEventoPadreSeleccionado } = this.state;
        if (obsComentarioRealizado.trim()) {
            addComment(nroFichaVentaSeleccionado, 'ACTIVIDAD-REALIZADO', obsComentarioRealizado, nroEventoPadreSeleccionado,'00',this.state.listaColaboradoresRealizado.map((item) =>  item.id))
            .then(({ data }) => {
                this.cerrarModalRealizado();
                this.componentDidMount();
                console.log(data);
                //this.props.openAlert(data);
            });
        }
    }

    cancelarRealizado = () => {
        console.log('cancelarRealizado');
        this.setState({
            muestraModalRealizado: 'none',
            colaboradorRealizado: '',
            listaColaboradoresRealizado: [],
            obsComentarioRealizado: '',
            nroFichaVentaSeleccionado: '',
            nroEventoPadreSeleccionado: ''
        });
    }

    validaEstado() {
        if (this.state.estado == 'P') {
            return(
                <div className='wrapper tableFdv'>
                    <div className='tableWrapper'>
                        <table className='table table-hover' style={{marginBottom: '100px'}}>
                            <thead className='table-head'>
                            <tr> 
                                <th>ACTIVIDAD</th>
                                <th>N° FICHA DE VENTA</th>
                                <th>NOMBRE DEL CLIENTE</th>
                                <th>FILIAL</th>
                                <th>SUCURSAL</th>
                                <th>ÁREA DE VENTA</th>
                                <th>FAMILIA</th>
                                <th>VENDEDOR</th>
                                <th>FECHA</th>
                                <th>HORA</th>
                                <th>RECHAZADO</th>
                                <th>REALIZADO</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.renderEventoActividadPendientes()}
                            </tbody>
                        </table>
                    </div>
                </div>
            )
        } else {
            return(
                <div className='wrapper tableFdv'>
                    <div className='tableWrapper'>
                        <table className='table table-hover' style={{marginBottom: '100px'}}>
                            <thead className='table-head'>
                            <tr>
                                <th>ACTIVIDAD</th>
                                <th>N° FICHA DE VENTA</th>
                                <th>NOMBRE DEL CLIENTE</th>
                                <th>FILIAL</th>
                                <th>SUCURSAL</th>
                                <th>ÁREA DE VENTA</th>
                                <th>FAMILIA</th>
                                <th>VENDEDOR</th>
                                <th>FECHA</th>
                                <th>HORA</th>
                                <th>ESTADO</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.renderEventoActividadProcesados()}
                            </tbody>
                        </table>
                    </div>
                </div>
            )
        }
    }

    renderEventoActividadPendientes() {
        return !this.state.listaEventoActividad ?
            [] : (this.state.listaEventoActividad.length > 0 ? (
                        this.state.listaEventoActividad.map((actividad, i) => (
                            <tr key={i}>
                                <td>{actividad.desTarea}</td>
                                <td>
                                    <ErrorUIComponent>
                                        <Link target="_blank" to={`/fichas-venta/${actividad.nroFichaVta}`}>
                                            {actividad.nroFichaVta}
                                        </Link>
                                    </ErrorUIComponent>

                                </td>
                                <td>{actividad.nomClie}</td>
                                <td>{actividad.nomFilial}</td>
                                <td>{actividad.nomSucursal}</td>
                                <td>{actividad.desAreaVta}</td>
                                <td>{actividad.desFamiliaVeh}</td>
                                <td>{actividad.nomUsuaSolicitante}</td>
                                <td>{moment(actividad.fecInicio).format('DD/MM/YYYY')}</td>
                                <td>{moment(actividad.fecInicio).format('HH:mm')}</td>
                                <td style={{ textAlign: "center"}}>{
                                    <center>
                                        <button className="btn btn-default btn-sm" style={{ margin: "15px 15px" }}
                                            onClick={e => 
                                                this.rechazarActividad(e, actividad)
                                            }>
                                            <i className='ion-plus' 
                                                style={{ cursor: "pointer" }}
                                                title="Rechazo"
                                                
                                            />
                                        </button>
                                    </center>
                                    }
                                </td>
                                <td style={{ textAlign: "center"}}>{
                                    <center>
                                        <button className="btn btn-default btn-sm" style={{ margin: "15px 15px" }}
                                            onClick={e => 
                                                this.realizarActividad(e, actividad)
                                            }>
                                            <i className='ion-plus' 
                                                style={{ cursor: "pointer" }}
                                                title="Realizado"
                                                
                                            />
                                        </button>
                                    </center>
                                    }
                                </td>

                            </tr>)))
                    : (
                        <tr>
                            <td colSpan='12'><p style={{textAling: 'center'}}> No existe registros para la busqueda
                                !!</p></td>
                        </tr>
                    )
            );
    }

    renderEventoActividadProcesados() {
        return !this.state.listaEventoActividad ?
            [] : (this.state.listaEventoActividad.length > 0 ? (
                        this.state.listaEventoActividad.map((actividad, i) => (
                            <tr key={i}>
                                <td>{actividad.desTarea}</td>
                                <td>
                                    <ErrorUIComponent>
                                        <Link target="_blank" to={`/fichas-venta/${actividad.nroFichaVta}`}>
                                            {actividad.nroFichaVta}
                                        </Link>
                                    </ErrorUIComponent>

                                </td>
                                <td>{actividad.nomClie}</td>
                                <td>{actividad.nomFilial}</td>
                                <td>{actividad.nomSucursal}</td>
                                <td>{actividad.desAreaVta}</td>
                                <td>{actividad.desFamiliaVeh}</td>
                                <td>{actividad.nomUsuaSolicitante}</td>
                                <td>{actividad.fecModiReg != null?moment(actividad.fecModiReg).format('DD/MM/YYYY'):'-'}</td>
                                <td>{actividad.fecModiReg != null?moment(actividad.fecModiReg).format('HH:mm'):'-'}</td>
                                <td>{IndexBandejaActividades.pillFormatter(actividad.indTarea)}</td>
                                

                            </tr>)))
                    : (
                        <tr>
                            <td colSpan='12'><p style={{textAling: 'center'}}> No existe registros para la busqueda
                                !!</p></td>
                        </tr>
                    )
            );
    }

    render() {

        const { estado } = this.state;

        return (

                <ErrorUIComponent>
                    <div>
                        <div className='pageHead'>
                            <div>
                                <div className='pageHead-rowContainer'>
                                <div className='pageHead-filters wrapper'>
                                        <div className='pageHead-tableConf-tabs'>
                                            <div className="col-md-2">
                                                <div className='form-group'>
                                                    {/*<label htmlFor='subject' className='labelInfo'>Actividad</label>*/}
                                                    <div className="select">
                                                        <select className='form-control' id='comboActividad' name='comboActividad'
                                                            value={this.state.comboActividad} onChange={this.changeCombos} >
                                                            <option value='0'>Seleccione Actividad</option>
                                                            {
                                                            this.state.listaTipoActividad.map(actividad => (
                                                                <option key={actividad.idMaeActividad} value={actividad.idMaeActividad}>
                                                                {actividad.descMaeActividad}
                                                                </option>
                                                            ))
                                                            }
                                                        </select>
                                                        <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className='form-group'>
                                                    {/*<label htmlFor='subject' className='labelInfo'>Actividad</label>*/}
                                                    <div className="select">
                                                        <select className='form-control' id='comboAreaVta' name='comboAreaVta'
                                                            value={this.state.comboAreaVta} onChange={this.changeCombos} >
                                                            <option value='0'>Seleccione Área de Venta</option>
                                                            {
                                                            this.state.listaAreaVta.map(areaVta => (
                                                                <option key={areaVta.id} value={areaVta.id}>
                                                                {areaVta.nombre}
                                                                </option>
                                                            ))
                                                            }
                                                        </select>
                                                        <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className='form-group'>
                                                    {/*<label htmlFor='subject' className='labelInfo'>Actividad</label>*/}
                                                    <div className="select">
                                                        <select className='form-control' id='comboFamilia' name='comboFamilia'
                                                            value={this.state.comboFamilia} onChange={this.changeCombos} >
                                                            <option value='0'>Seleccione Familia</option>
                                                            {
                                                            this.state.listaFamilia.map(familia => (
                                                                <option key={familia.codFamiliaVeh} value={familia.codFamiliaVeh}>
                                                                {familia.desFamiliaVeh}
                                                                </option>
                                                            ))
                                                            }
                                                        </select>
                                                        <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className='form-group'>
                                                    {/*<label htmlFor='subject' className='labelInfo'>Actividad</label>*/}
                                                    <div className="select">
                                                        <select className='form-control' id='comboSucursal' name='comboSucursal'
                                                            value={this.state.comboSucursal} onChange={this.changeCombos} >
                                                            <option value='0'>Seleccione Sucursal</option>
                                                            {
                                                            this.state.listaFiliales.map(sucursal => (
                                                                <option key={sucursal.id} value={sucursal.id}>
                                                                {sucursal.nombre}
                                                                </option>
                                                            ))
                                                            }
                                                        </select>
                                                        <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                                                    </div>
                                                </div>
                                            </div>  

                                            <div className="col-md-2">
                                                <Autocomplete
                                                    getItemValue={item => item.idUsuario.toString()}
                                                    value={this.state.colaborador}
                                                    items={this.state.listaColaboradores?this.state.listaColaboradores:listarColaboradorNull}
                                                    renderItem={(item, isHighlighted) =>
                                                      <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                                                        {`${item.apellidos} ${item.nombre}`}
                                                      </div>
                                                    }
                                                    onChange={this.changeColaborador}
                                                    menuStyle={menuStyle}
                                                    inputProps={inputPropsColaborador}
                                                    wrapperStyle={{ display: 'block' }}
                                                    onSelect={this.selectColaborador}
                                                />                
                                            </div>    

                                            <div className="col-md-2">
                                                <Autocomplete
                                                    getItemValue={item => item.codigo.toString()}
                                                    value={this.state.cliente}
                                                    items={this.state.listaClientes?this.state.listaClientes:listaClientesNull}
                                                    renderItem={(item, isHighlighted) =>
                                                        <div key={item.codigo} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                                                        {`${item.nombre}`}
                                                        </div>
                                                    }
                                                    onChange={this.changeCliente}
                                                    menuStyle={menuStyle}
                                                    inputProps={inputPropsCliente}
                                                    wrapperStyle={{ display: 'block' }}
                                                    onSelect={this.selectCliente}
                                                />                
                                            </div>           
                                        </div>
                                    </div>
                                </div>
                            
                                <div className='pageHead-rowContainer'>
                                    <div className='pageHead-filters wrapper'>
                                        <div className='pageHead-tableConf-tabs'>
                                            <div className='fdv-section-actions'>
                                                <button
                                                className='btn btn-primary'
                                                onClick={this.filtrarListaEventoActividad}
                                                >
                                                Buscar
                                                </button>
                                            </div>   
                                            
                                            &nbsp;
                                            &nbsp;
                                            &nbsp;

                                            <div className='fdv-section-actions'>
                                                <button
                                                className='btn btn-primary'
                                                onClick={this.limpiarFiltros}
                                                >
                                                Limpiar
                                                </button>
                                            </div>                 
                                        </div>
                                    </div>
                                </div>

                                {/* PESTAÑAS DE PENDIENTES Y REALIZADO */}
                                <div className='pageHead-rowContainer'>
                                    <div className='pageHead-tableConf wrapper'>
                                        <div className='pageHead-tableConf-tabs'>
                                            <ul className='tabs' role='tablist'>
                                                <li className={`tabs-item ${this.state.estado === 'P' ? 'active' : null}`}>
                                                    <a className='tabs-item-link checkDeGrillaCerrar'
                                                        onClick={() => this.handleClick('P')}>Pendientes</a>
                                                </li>
                                                <li className={`tabs-item ${this.state.estado === 'R' ? 'active' : null}`}>
                                                    <a className='tabs-item-link checkDeGrillaCerrar'
                                                        onClick={() => this.handleClick('R')}>Ejecutado</a>
                                                </li>
                                            </ul>
                                        </div>
                                        {/*<div className='pageHead-tableConf-pagCols'>
                                            <nav className='pag'>
                                                <p className='pag-label'>
                                                    <span>{this.state.nInicio}</span><span> -</span><span> {this.state.nFin}</span><span> de</span><span> {this.state.totalRegistros}</span>
                                                </p>
                                                <div className='pag-arrows'>
                                                    <a className='btn btn-default pag-link checkDeGrillaCerrar'
                                                        title='Anterior' onClick={this.atras}><i
                                                        className='ion-chevron-left'/></a>
                                                    <a className='btn btn-default pag-link checkDeGrillaCerrar'
                                                        title='Siguiente' onClick={this.siguiente}><i
                                                        className='ion-chevron-right'/></a>
                                                </div>
                                            </nav>
                                        </div>*/}
                                    </div>
                                </div>
                            </div>

                            {/* MODAL RECHAZADO */}                
                            <div className='modal extraFilter' id='moreFilters' role='dialog' data-backdrop='static'
                                style={{display: this.state.muestraModalRechazado}}>
                                <div className='modal-dialog' role='document'>
                                    <button className='btn btn-sm btn-blue modal-close' data-dismiss='modal'
                                            onClick={this.cerrarModalRechazado}>Cerrar ventana
                                    </button>
                                    <div className='modal-content'>
                                        <div className='modal-body'>
                                            <h2 className='modal-title'>Rechazar Actividad</h2>
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='form-group'>
                                                        <label className='labelInfo' htmlFor='obsMotivoRechazo'>Motivo de Rechazo</label>
                                                        <textarea className='form-control' placeholder='Ingresa el motivo aquí' name='obsMotivoRechazo' id='obsMotivoRechazo' value={this.state.obsMotivoRechazo} onChange={this.onChangeValueObsRechazo} maxLength='300' />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='pillSelct'>
                                                        <p className='labelInfo'>Notifica a un colaborador</p>
                                                        <div className='pillSelct-field'>
                                                        <Autocomplete
                                                            getItemValue={item => item.idUsuario.toString()}
                                                            items={this.props.colaboradores}
                                                            renderItem={(item, isHighlighted) =>
                                                                <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                                                                    {`${item.apellidos} ${item.nombre}`}
                                                                </div>
                                                            }
                                                            onChange={(e) => {
                                                                if (e.target.value.length >= 2) {
                                                                this.props.fetchColaboradores(e.target.value);
                                                                }
                                                                if (e.target.value.length === 0) {
                                                                this.props.clearColaboradores();
                                                                }
                                                                this.setState({ colaboradorRechazo: e.target.value });
                                                            }}
                                                            value={this.state.colaboradorRechazo}
                                                            autoHighlight={this.state.trueComplete}
                                                            onSelect={(key) => {
                                                                const name = this.props.colaboradores
                                                                    .filter(({ idUsuario }) =>
                                                                        idUsuario.toString() === key)[0].nombre;

                                                                const apellidos = this.props.colaboradores
                                                                    .filter(({ idUsuario }) =>
                                                                        idUsuario.toString() === key)[0].apellidos;
                                                                const varpersona = { id: key, apellido: `${apellidos} ${name}` };

                                                                if (!(this.state.listaColaboradoresRechazo.indexOf(varpersona)>=0)) {
                                                                    this.setState({
                                                                        listaColaboradoresRechazo: [...this.state.listaColaboradoresRechazo,varpersona],
                                                                        colaboradorRechazo: '',
                                                                    });
                                                                }
                                                                this.props.clearColaboradores();
                                                            }}


                                                            menuStyle={{
                                                                position: 'absolute',
                                                                left: '0',
                                                                top: '100%',
                                                                maxHeight: '350px',
                                                                overflow: 'auto',
                                                                border: '1px solid #cccccc',
                                                            }}
                                                            inputProps={{
                                                                className: 'form-control awesomplete pillSelct-input',
                                                            }}
                                                            wrapperStyle={{
                                                                position: 'relative',
                                                                zIndex: '10',
                                                            }}
                                                        />
                                                        </div>
                                                        <div className='pillSelct-pills'>
                                                        {
                                                            this.state.listaColaboradoresRechazo.map(Rows => (
                                                                <label className='pill pill-cyan pillSelct-pills-item'>{Rows.apellido}
                                                                <button
                                                                    className='pillSelct-delete'
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            listaColaboradoresRechazo: this.state.listaColaboradoresRechazo.filter(x => x !== Rows),
                                                                        });
                                                                    }}
                                                                ><i className='icon ion-close pill-close' />
                                                                </button>
                                                                </label>
                                                            ))
                                                        }

                                                        </div>

                                                    </div>
                                                </div>

                                            </div>

                                            <div className='row'>                        
                                                <div className='col-md-12'>
                                                    <div className='modal-actions'>
                                                        <button className='btn btn-default pull-left' data-dismiss='modal' onClick={this.cancelarRechazado} >Cancelar</button>
                                                        <button className='btn btn-primary pull-right' data-dismiss='modal' onClick={this.enviarRechazado} >Enviar</button>
                                                    </div>        
                                                </div>
                                            </div>                

                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* MODAL REALIZADO */}
                            <div className='modal extraFilter' id='moreFilters' role='dialog' data-backdrop='static'
                                style={{display: this.state.muestraModalRealizado}}>
                                <div className='modal-dialog' role='document'>
                                    <button className='btn btn-sm btn-blue modal-close' data-dismiss='modal'
                                            onClick={this.cerrarModalRealizado}>Cerrar ventana
                                    </button>
                                    <div className='modal-content'>
                                        <div className='modal-body'>
                                            <h2 className='modal-title'>Realizar Actividad</h2>
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='form-group'>
                                                        <label className='labelInfo' htmlFor='obsComentarioRealizado'>Comentario</label>
                                                        <textarea className='form-control' placeholder='Ingresa el motivo aquí' name='obsComentarioRealizado' id='obsComentarioRealizado' value={this.state.obsComentarioRealizado} onChange={this.onChangeValueObsRealizado} maxLength='300' />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='pillSelct'>
                                                        <p className='labelInfo'>Notifica a un colaborador</p>
                                                        <div className='pillSelct-field'>
                                                        <Autocomplete
                                                            getItemValue={item => item.idUsuario.toString()}
                                                            items={this.props.colaboradores}
                                                            renderItem={(item, isHighlighted) =>
                                                                <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                                                                    {`${item.apellidos} ${item.nombre}`}
                                                                </div>
                                                            }
                                                            onChange={(e) => {
                                                                if (e.target.value.length >= 2) {
                                                                this.props.fetchColaboradores(e.target.value);
                                                                }
                                                                if (e.target.value.length === 0) {
                                                                this.props.clearColaboradores();
                                                                }
                                                                this.setState({ colaboradorRealizado: e.target.value });
                                                            }}
                                                            value={this.state.colaboradorRealizado}
                                                            autoHighlight={this.state.trueComplete}
                                                            onSelect={(key) => {
                                                                const name = this.props.colaboradores
                                                                    .filter(({ idUsuario }) =>
                                                                        idUsuario.toString() === key)[0].nombre;

                                                                const apellidos = this.props.colaboradores
                                                                    .filter(({ idUsuario }) =>
                                                                        idUsuario.toString() === key)[0].apellidos;
                                                                const varpersona = { id: key, apellido: `${apellidos} ${name}` };

                                                                if (!(this.state.listaColaboradoresRealizado.indexOf(varpersona)>=0)) {
                                                                    this.setState({
                                                                        listaColaboradoresRealizado: [...this.state.listaColaboradoresRealizado,varpersona],
                                                                        colaboradorRealizado: '',
                                                                    });
                                                                }
                                                                this.props.clearColaboradores();
                                                            }}


                                                            menuStyle={{
                                                                position: 'absolute',
                                                                left: '0',
                                                                top: '100%',
                                                                maxHeight: '350px',
                                                                overflow: 'auto',
                                                                border: '1px solid #cccccc',
                                                            }}
                                                            inputProps={{
                                                                className: 'form-control awesomplete pillSelct-input',
                                                            }}
                                                            wrapperStyle={{
                                                                position: 'relative',
                                                                zIndex: '10',
                                                            }}
                                                        />
                                                        </div>
                                                        <div className='pillSelct-pills'>
                                                        {
                                                            this.state.listaColaboradoresRealizado.map(Rows => (
                                                                <label className='pill pill-cyan pillSelct-pills-item'>{Rows.apellido}
                                                                <button
                                                                    className='pillSelct-delete'
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            listaColaboradoresRealizado: this.state.listaColaboradoresRealizado.filter(x => x !== Rows),
                                                                        });
                                                                    }}
                                                                ><i className='icon ion-close pill-close' />
                                                                </button>
                                                                </label>
                                                            ))
                                                        }

                                                        </div>

                                                    </div>
                                                </div>

                                            </div>

                                            <div className='row'>                        
                                                <div className='col-md-12'>
                                                    <div className='modal-actions'>
                                                        <button className='btn btn-default pull-left' data-dismiss='modal' onClick={this.cancelarRealizado} >Cancelar</button>
                                                        <button className='btn btn-primary pull-right' data-dismiss='modal' onClick={this.enviarRealizado} >Enviar</button>
                                                    </div>        
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        {this.validaEstado()}

                          

                    </div>
                    
                </ErrorUIComponent>
            
        );
    }

}

function mapStateToProps(state) {
    return {
        filiales: state.filiales,
        familias: state.familias,
        colaboradores: state.colaboradores,
        clientes: state.clientes
    };
}

IndexBandejaActividades.defaultProps = {
    familias: [],
    filiales: [],
    clientes:[],
    colaboradores: []
  };


export default connect(mapStateToProps, 
    {
    fetchColaboradores,
    clearColaboradores,
    fetchPermisos,
    fetchTipoActividad,
    fetchHistorialFDV,
    fetchFamilia,
    fetchFiliales,
    fetchAreasVenta,
    fetchVendedores,
    clearVendedores,
    fetchClientes,
    clearClientes,
    fetchEventoActividad
})(IndexBandejaActividades);

// [F] MNBARDALES FECHA PASE 27/09/2021 


// WEBPACK FOOTER //
// ./src/containers/IndexBandejaActividades.js